import React from 'react';
import { SearchFilterTemplate } from 'themes/components';
import { setCurrentView } from 'core/utils';
import { SearchFilterStore } from 'core/components';

@setCurrentView((rootStore, componentProps) => new SearchFilterStore(rootStore, componentProps), 'searchFilterStore')
class SearchFilter extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <SearchFilterTemplate {...this.props} />;
	}
}

export default SearchFilter;



// WEBPACK FOOTER //
// ./src/core/components/SearchFilter.jsx